module.exports = __webpack_public_path__ + "img/circular.92b6abd3.gif";